// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SetDetail_wrapper__jyjMy","cvButton":"SetDetail_cvButton__s25Il"};